/**
 * Converts a pre-signed S3 URL to an S3 path
 * @param presignedUrl - The pre-signed S3 URL
 * @returns The S3 path without domain and query parameters
 * 
 * Example:
 * Input: https://bucket-name.s3.region.amazonaws.com/folder/file.jpg?X-Amz-Algorithm=...
 * Output: folder/file.jpg
 */
export const getS3PathFromSignedUrl = (presignedUrl: string): string => {
    try {
        // Create URL object from the pre-signed URL
        const url = new URL(presignedUrl);
        
        // Get the pathname (everything after the domain)
        // and remove the leading slash
        const path = url.pathname.slice(1);
        
        return path;
    } catch (error) {
        console.error('Error converting pre-signed URL to S3 path:', error);
        return '';
    }
};

/**
 * Creates an S3 URL from bucket name and path
 * @param bucketName - The S3 bucket name
 * @param s3Path - The S3 path
 * @returns The complete S3 URL (not pre-signed)
 */
export const createS3Url = (bucketName: string, s3Path: string): string => {
    try {
        return `https://${bucketName}.s3.amazonaws.com/${s3Path}`;
    } catch (error) {
        console.error('Error creating S3 URL:', error);
        return '';
    }
};

/**
 * Extracts bucket name from a pre-signed URL
 * @param presignedUrl - The pre-signed S3 URL
 * @returns The bucket name
 */
export const getBucketFromSignedUrl = (presignedUrl: string): string => {
    try {
        const url = new URL(presignedUrl);
        // Extract bucket name from hostname
        // Format: bucket-name.s3.region.amazonaws.com
        const hostname = url.hostname;
        return hostname.split('.')[0];
    } catch (error) {
        console.error('Error extracting bucket name:', error);
        return '';
    }
}; 